import { Component, Inject, ViewChild } from '@angular/core';
import { SIDENAV_CONTENT_DATA } from '../../../shared/sidenav/sidenav-content/sidenav-content.service';
import { SimpleOrganization } from '../../../../../services/organization/organization.service';
import { SidenavContentModule } from '../../../shared/sidenav/sidenav-content/sidenav-content.module';
import { MatButtonModule } from '@angular/material/button';
import { ToggleListComponent } from '../../../shared/toggle-list/toggle-list.component';
import { EmptyStateModule } from '../../../shared/empty-state/empty-state.module';
import { AsyncPipe, I18nPluralPipe } from '@angular/common';
import { OrganizationDataService } from '../../../../../services/organization/organization-data.service';
import { AvatarBlockModule } from '../../../shared/avatar-block/avatar-block.module';
import { SidenavContentRef } from '../../../shared/sidenav/sidenav-content/sidenav-content-ref';
import { I18nMap } from '../../../../../models/entities/i18n-map';
import { IsTypeofDirective } from '../../../shared/directives/typeof.directive';

export interface OrganizationSidenavInput {
    title: string;
    required: boolean;

    // preselected ids
    selectedOrganizationIds?: number[];

    // provide confirmation button label with string or i18n-mapped object
    confirmButton?: string|I18nMap;
}

export interface OrganizationSidenavOutput {
    success: true;
    selectedCommunities: SimpleOrganization[];
}

@Component({
    selector: 'app-organization-sidenav',
    templateUrl: './organization-sidenav.component.html',
    standalone: true,
    imports: [
        SidenavContentModule,
        ToggleListComponent,
        MatButtonModule,
        EmptyStateModule,
        AsyncPipe,
        AvatarBlockModule,
        IsTypeofDirective,
        I18nPluralPipe,
    ],
})
export class OrganizationSidenavComponent
{
    @ViewChild(ToggleListComponent<SimpleOrganization>) listRef: ToggleListComponent<SimpleOrganization>;

    readonly confirmLabelMapping: I18nMap = {
        '=0': 'Select Communities',
        '=1': 'Select 1 Community',
        other: 'Select # Communities',
    };

    constructor(
            private _organizationDataService: OrganizationDataService,
            private _sidenavRef: SidenavContentRef<OrganizationSidenavComponent>,
            @Inject(SIDENAV_CONTENT_DATA) public data: OrganizationSidenavInput,
    ) {
    }

    get organizations$() {
        return this._organizationDataService.orgList$;
    }

    confirmSelection() {
        if (this.listRef.validate) {
            const output: OrganizationSidenavOutput = {
                success: true,
                selectedCommunities: this.listRef.combinedValue,
            };

            this._sidenavRef.close(output);
        }
    }
}
